<template>
    <div>
        <b-badge variant="danger" size="sm" class="click-me" @click.prevent="logoutUser" href="#">Log Out</b-badge>
        <h1>
            Gifts Lists
        </h1>
        <b-button   variant="outline-success"
                    class="click-me"
                    @click="getGifts()">
            Refresh
        </b-button>
        <b-button   @click="newGift('new')"
                    variant="success">
            {{ show.new.gift ? 'Close New Gift Section' : 'Add a Gift' }}
        </b-button>
        <div    v-if="show.new.gift">
            <hr>
            <b-form-input   v-model="gift.title"
                            placeholder="Gift Title">
            </b-form-input>
            <b-form-input   v-model="gift.url"
                            placeholder="Gift URL">
            </b-form-input>
            <b-select   v-model="gift.for"
                        :options="giftsFor">
                
            </b-select>
            <br>
            <b-button   @click="addGift(gift.for)"
                        variant="success">Add</b-button>
        </div>
        <hr>
        <div>
            Select List to View: <b-select  v-model="listFor"   :options="giftsFor"></b-select>
        </div>
        <hr>
        <!-- Gifts List/Table -->
        <h3 style="background-color: lightgreen;">Gifts for {{ listFor }}</h3>
        <h5 class="text-center" v-if="user != 'Santa'">
            <span style="color: darkred;">Santa</span> <span style="color: darkgreen;">last</span> <span style="color: darkred;">checked</span> <span style="color: darkgreen;">this</span> <span style="color: darkred;">list</span> <span style="color: darkgreen;">{{ santaCheck[listFor] }}</span> <span style="color: darkred;">minutes</span> <span style="color: darkgreen;">ago!</span>
        </h5>
        <b-table hover
                        small
                        caption-top
                        responsive
                        striped
                        show-empty
                        :items="giftLists[listFor]"
                        :fields="fields">

            <!-- Data -->
            <template v-slot:cell(title)="row">
                {{ row.item.purchased && user != row.item.for ? '[PURCHASED] ' + row.item.title : row.item.title }}
            </template>
            <template v-slot:cell(url)="data">
                <a :href="data.value" target="_blank" v-if="data.value != '#'">Click to view</a>
            </template>
            <template   v-slot:cell(purchased)="row">
                <span v-if="user != row.item.for">{{ row.item.purchased ? 'Yes' : 'No' }}</span>
                <span v-if="user == row.item.for">---</span>
            </template>
            <template   v-slot:cell(actions)="row">
                <b-button   v-if="(!row.item.purchased && user != row.item.for)"
                            variant="success"
                            @click="purchaseGift(row.item)">Purchase</b-button>
                <b-button   v-if="(row.item.purchased && user != row.item.for)"
                            variant="warning"
                            @click="undoPurchase(row.item)">Un-Purchase</b-button>
                <b-button   v-if="(user == row.item.for || user == 'Ben' || user == 'Santa')"
                            variant="danger"
                            @click="deleteGift(row.item._id)">Delete</b-button>
            </template>
        </b-table>
    </div>    
</template>

<script>
/* eslint-disable no-console */
import axios from 'axios'
import { ipConfig } from '../../_configs'

export default {
    data() {
        return {
            bGifts: [],
            cGifts: [],
            giftLists: {
                'Amber': [],
                'Ben': [],
                'Cassie': [],
                'Cali': [],
                'Grandmama': [],
                'Jonathan': [],
                'Karen': [],
                'Ken': [],
                'Lori Jo': [],
                'Nana': [],
                'Papa': [],
                'Stacey': [],
                'Uncle John': []
            },
            listFor: '',
            giftsFor: [
                { value: '', text: 'Please Select Who For' },
                { value: 'Amber', text: 'Amber' },
                { value: 'Ben', text: 'Ben' },
                { value: 'Cassie', text: 'Cassie' },
                { value: 'Cali', text: 'Cali' },
                { value: 'Grandmama', text: 'Grandmama' },
                { value: 'Jonathan', text: 'Jonathan' },
                { value: 'Karen', text: 'Karen' },
                { value: 'Ken', text: 'Ken' },
                { value: 'Lori Jo', text: 'Lori Jo' },
                { value: 'Nana', text: 'Nana' },
                { value: 'Papa', text: 'Papa' },
                { value: 'Stacey', text: 'Stacey' },
                { value: 'Uncle John', text: 'Uncle John' }
            ],
            fields: [
                {
                    key: 'title',
                    label: 'Gift',
                    sortable: true
                },
                {
                    key: 'url',
                    label: 'Link',
                    sortable: false
                },
                {
                    key: 'purchased',
                    label: 'Already Purchased',
                    sortable: true
                },
                {
                    key: 'addedBy',
                    label: 'Added By',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Actions',
                    sortable: false
                },
            ],
            show: {
                new: {
                    gift: false
                }
            },
            gift: {
                title: '',
                url: '',
                for: ''
            },
            santaCheck: {
                'Amber': 0,
                'Ben': 0,
                'Cassie': 0,
                'Cali': 0,
                'Grandmama': 0,
                'Jonathan': 0,
                'Karen': 0,
                'Ken': 0,
                'Lori Jo': 0,
                'Nana': 0,
                'Papa': 0,
                'Stacey': 0,
                'Uncle John': 0
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.authentication.user
        }
    },
    methods: {
        newGift(person) {
            this.gift.title = ''
            this.gift.url = ''
            this.gift.for = ''
            this.show[person].gift = !this.show[person].gift
        },
        addGift(person){
            let url = 'http://' + ipConfig.default.NetIP + ':3000/gifts/new'
            let giftParams = {
                title: this.gift.title,
                url: this.gift.url,
                for: person,
                addedBy: this.user
            }

            if(this.gift.title != '' && this.gift.url != '' && this.gift.for != '') {
                axios.post(url, giftParams)
                    .then(response => {
                        this.gift.title = ''
                        this.gift.url = ''
                        this.gift.for = ''
                        alert(response.data.title + ' has been added')
                        this.getGifts()
                    }).catch(err => {
                        console.log(err)
                    })
            } else {
                alert('Please make sure you have added a name for the gift, either a url or a # for the URL, and selected who it is for')
            }
        },
        deleteGift(id) {
            let url = 'http://' + ipConfig.default.NetIP + ':3000/gifts/delete/' + id

            let msg = 'Are you sure you want to delete the gift?'
            if(confirm(msg)){
                axios.post(url)
                    .then(() => {
                        this.getGifts()
                    }).catch(err => {
                        console.log(err)
                    })
            }
        },
        purchaseGift(gift) {
            let updatedGift = {
                gift: {
                    title: gift.title,
                    url: gift.url,
                    for: gift.for,
                    addedBy: gift.addedBy,
                    purchased: true
                }
            }
            let url = 'http://' + ipConfig.default.NetIP + ':3000/gifts/update/' + gift._id
            let msg = gift.title + ' was purchased?'

            if(confirm(msg)) {
                axios.post(url, updatedGift)
                    .then(response => {
                        this.getGifts()
                        alert(response.data.title + 'was marked as purchased')
                    }).catch(err => {
                        console.log(err)
                    })
            }
        },
        undoPurchase(gift) {
            let updatedGift = {
                gift: {
                    title: gift.title,
                    url: gift.url,
                    for: gift.for,
                    purchased: false
                }
            }
            let url = 'http://' + ipConfig.default.NetIP + ':3000/gifts/update/' + gift._id
            let msg = 'Mark ' + gift.title + ' as not purchased?'

            if(confirm(msg)) {
                axios.post(url, updatedGift)
                    .then(response => {
                        this.getGifts()
                        alert(response.data.title + 'was marked as not purchased')
                    }).catch(err => {
                        console.log(err)
                    })
            }
        },
        getGifts() {
            let url = 'http://' + ipConfig.default.NetIP + ':3000/gifts/all'
            let giftIsFor = ''
            let giftAddedBy = ''
            for (const prop in this.giftLists) {
                this.giftLists[prop] = []
            }

            axios.get(url)
                .then(response => {
                    response.data.forEach(gift => {
                        giftIsFor = gift.for
                        giftAddedBy = gift.addedBy
                        if((giftIsFor == this.user && giftAddedBy == this.user) || (giftIsFor != this.user)) {
                            this.giftLists[giftIsFor].push(gift)
                        }

                        for(const prop in this.santaCheck) {
                            let minutes = Math.floor(Math.random() * Math.floor(97))
                            this.santaCheck[prop] = minutes
                        }
                    })
                }).catch(err => {
                    alert(err)
                })
        },
        logoutUser() {
            this.$store.dispatch('authentication/logout', { action: 'Log Out'})
            this.$router.push('/')
        },
    },
    created() {
        if(this.user == 'Santa') {
            this.listFor = ''
        } else {
            this.listFor = this.user
        }
        this.getGifts()
    }
}
</script>

<style scoped>

    .click-me {
        cursor: pointer;
        float: right;
    }

</style>